import initFieldValues from './initFieldValues';
import setSubscribersFields, { getSelectionRange, updateCursorTarget } from './setSubscribersFields';
import setFieldErrors from './setFieldErrors';
import updateCustomValues from './updateCustomValues';
import updateOptinValues from './updateOptinValues';
import captureFields from './captureFields';
import updateTouched from './updateTouched';
import validateFields, { validateCustomFields, validateOptinsFields } from './validateFields';
import selectCalendar from './selectCalendar';
import setParamFieldValues from './setParamFieldValues';
import setters from './setters';

import {
    validateRequired,
    addRequired,
    requiredHasValue,
} from './required';

export const actions = {
    initFieldValues,
    addRequired,
    validateRequired,
    requiredHasValue,
    setSubscribersFields,
    setFieldErrors,
    updateCustomValues,
    updateOptinValues,
    captureFields,
    updateTouched,
    validateFields,
    selectCalendar,
    setParamFieldValues,
    validateCustomFields,
    validateOptinsFields,
    getSelectionRange,
    updateCursorTarget,
    ...setters,
};

export default actions;
